import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const RolesShow = ({ match }) => {
	const {
		params: { roleID },
	} = match;

	const [permissions, setPermissions] = useState([]);
	const [slug, setSlug] = useState("");
	const [selectedPermissions, setSelectedPermissions] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل الصلاحية",
				breadcrumb: "صلاحيات المشرفين",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/roles/${roleID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setSlug(response.data.data.roles.slug);
				const arr = [];
				// eslint-disable-next-line array-callback-return
				response.data.data.roles.permissions.map(per => {
					// eslint-disable-next-line array-callback-return
					per.permissions.map(per2 => {
						arr.push(per2.name);
					});
				});
				setSelectedPermissions(arr);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
		// get permission
		axios
			.get(process.env.REACT_APP_API_URL + "/permissions", {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setPermissions(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleSelect = permission => {
		if (selectedPermissions.includes(permission)) {
			const arr = selectedPermissions.filter(item => item !== permission);
			setSelectedPermissions(arr);
		} else {
			setSelectedPermissions(arr => [...arr, permission]);
		}
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (selectedPermissions.length === 0) {
			toast.error("برجاء اختيار صلاحية واحدة على الأقل");
		} else {
			setLoading(true);
			axios
				.put(`${process.env.REACT_APP_API_URL}/roles/${roleID}`, {
					slug: slug,
					permission: selectedPermissions,
				})
				.then(function (response) {
					toast.success("تم تحديث الصلاحية بنجاح!");
					setLoading(false);
				})
				.catch(function (error) {
					setLoading(false);
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
				});
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="form-item">
					<label htmlFor="">اسم الصلاحية</label>
					<input
						type="text"
						onChange={e => setSlug(e.target.value)}
						value={slug}
						required
					/>
				</div>
				<div className="row gy-4">
					{permissions.map(permission => (
						<div key={permission.module_name} className="col-md-3">
							<div className="perItem">
								<h1>{permission.slug}</h1>
								<ul className="list-unstyled">
									{permission.permissions.map(per => (
										<li key={per.id}>
											<input
												type="checkbox"
												id={per.name}
												onChange={() => handleSelect(per.name)}
												checked={
													selectedPermissions.includes(per.name) ? true : false
												}
											/>
											<label htmlFor={per.name}>{per.slug}</label>
										</li>
									))}
								</ul>
							</div>
						</div>
					))}
				</div>
				<div className="form-item" style={{ marginTop: "30px" }}>
					<button className="bt bt-success">ارسال</button>
				</div>
			</form>
		</section>
	);
};

export default RolesShow;
